export default __webpack_public_path__ + "static/media/zh.7977e12a.svg";